import { UserDto } from "./userApi";

const TOKEN_KEY = "eckenmoorhexen.auth.token";
const USER_KEY = "eckenmoorhexen.auth.user";
const EXPIRES_KEY = "eckenmoorhexen.auth.expiresAt";
export const AUTH_CHANGED_EVENT = "eckenmoorhexen:auth-changed";
export const AUTH_LOGIN_REQUESTED_EVENT = "eckenmoorhexen:auth-login-requested";

export interface AuthSession {
  token: string;
  expiresAtUtc: string;
  user: UserDto;
}

export function saveAuthSession(session: AuthSession) {
  localStorage.setItem(TOKEN_KEY, session.token);
  localStorage.setItem(USER_KEY, JSON.stringify(session.user));
  localStorage.setItem(EXPIRES_KEY, session.expiresAtUtc);
  window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
}

export function loadAuthSession(): AuthSession | null {
  const token = localStorage.getItem(TOKEN_KEY);
  const user = localStorage.getItem(USER_KEY);
  const expiresAtUtc = localStorage.getItem(EXPIRES_KEY);

  if (!token || !user || !expiresAtUtc) {
    return null;
  }

  const expiresAt = new Date(expiresAtUtc);

  if (Number.isNaN(expiresAt.getTime()) || expiresAt <= new Date()) {
    clearAuthSession();
    return null;
  }

  return {
    token,
    expiresAtUtc,
    user: JSON.parse(user) as UserDto,
  };
}

export function clearAuthSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(EXPIRES_KEY);
  window.dispatchEvent(new Event(AUTH_CHANGED_EVENT));
}

export function requestLoginDialog() {
  window.dispatchEvent(new Event(AUTH_LOGIN_REQUESTED_EVENT));
}
